import StaffManagementCheckInSetupForm from "./staff-management-check-in-setup-form";
import StaffManagementFormFields from "./fields";


const StaffManagementForms = {
    CheckInSetup: StaffManagementCheckInSetupForm,
    Fields: StaffManagementFormFields,
};

export default StaffManagementForms;
